import { ConsentUpdate, Purpose } from '@mfec/types/model';

//
// Compares two purposes and returns only those with different "granted" status between the two purposes.
// The format returned can be used for api4p endpoints like postConsentsUpdateList
//
export const diffPurposesAsPayload = (initialPurpose: Purpose, activePurpose : Purpose) : ConsentUpdate[] => {
  const changedConsents : ConsentUpdate[] = [];

  initialPurpose.subscriptions.forEach((initialSubscription) => {
    // The subscription selected by the customer
    const activeSubscription = activePurpose.subscriptions.find((sub) => sub.msisdn === initialSubscription.msisdn);

    if (!activeSubscription) throw new Error(`Subscription "${initialSubscription.msisdn}" was not found in the active purpose data`);

    initialSubscription.apps.forEach((initialApp) => {
      // The app selected by the customer
      const activeApp = activeSubscription?.apps.find((app) => app.name === initialApp.name);
      if (!activeApp) throw new Error(`App "${initialApp.name}" was not found in the active purpose data`);

      // Only add it if the status is different
      if (initialApp.granted !== activeApp.granted) {
        changedConsents.push({ id: activeApp.consentId, status: activeApp.granted ? 'active' : 'revoked' });
      }
    });
  });

  return changedConsents;
};
